import { useChatAgentRecommendation } from './useChatAgentRecommendation';

export const useBudgetRecommendation = onBudgetChange => {
    const { value: recommendation, remove } = useChatAgentRecommendation('budget');

    const apply = () => {
        onBudgetChange(currentBudget => ({ ...currentBudget, ...recommendation }));
        remove();
    };

    return {
        recommendation,
        apply,
        remove,
    };
};
